"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddListTokenPropertyForm = exports.TokenTypeDropdown = exports.AddTokenForm = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var AddTokenInput_1 = require("Project/Actions/Tokens/AddTokenInput/AddTokenInput");
var getTokenTypeDisplayText = function (type) {
    if (type === Types_1.TokenDataType.String) {
        return "Text";
    }
    else if (type === Types_1.TokenDataType.List) {
        return "Repeating";
    }
    else {
        return "";
    }
};
var TokenTypeDropdown = (0, mobx_react_1.observer)(function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "token-type-dropdown" },
        react_1.default.createElement("label", { className: "token-type-dropdown__label" }, "Token type"),
        react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: "tokens-panel__option-menu token-type-dropdown__option-menu nested-portal", size: "small", button: react_1.default.createElement(kaleidoscope_1.Button, { className: "token-type-dropdown__action-btn", decorator: kaleidoscope_1.ButtonDecorator.Dropdown, type: kaleidoscope_1.ButtonType.Secondary }, getTokenTypeDisplayText(value)), autoStack: true },
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { selected: value === Types_1.TokenDataType.String, onClick: function () { return onChange(Types_1.TokenDataType.String); } }, getTokenTypeDisplayText(Types_1.TokenDataType.String)),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { selected: value === Types_1.TokenDataType.List, onClick: function () { return onChange(Types_1.TokenDataType.List); } }, getTokenTypeDisplayText(Types_1.TokenDataType.List)))));
});
exports.TokenTypeDropdown = TokenTypeDropdown;
var AddTokenForm = (function (_super) {
    __extends(AddTokenForm, _super);
    function AddTokenForm() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.tokenType = Types_1.TokenDataType.String;
        _this.onAddToken = function (name) {
            return _this.props.onAddToken({ name: name, dataType: _this.tokenType });
        };
        return _this;
    }
    AddTokenForm.prototype.onTokenTypeChange = function (type) {
        this.tokenType = type;
    };
    AddTokenForm.prototype.render = function () {
        var allowListTokens = this.props.allowListTokens;
        return (react_1.default.createElement("div", { className: "add-token-form" },
            allowListTokens && react_1.default.createElement(TokenTypeDropdown, { value: this.tokenType, onChange: this.onTokenTypeChange }),
            react_1.default.createElement(AddTokenInput_1.AddTokenInput, { className: "add-token-form__input", maxTokenLength: Types_1.MAX_CUSTOM_TOKEN_NAME_LENGTH, onAddToken: this.onAddToken })));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddTokenForm.prototype, "tokenType", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Types_1.TokenDataType !== "undefined" && Types_1.TokenDataType) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], AddTokenForm.prototype, "onTokenTypeChange", null);
    AddTokenForm = __decorate([
        mobx_react_1.observer
    ], AddTokenForm);
    return AddTokenForm;
}(react_1.default.Component));
exports.AddTokenForm = AddTokenForm;
var AddListTokenPropertyForm = (function (_super) {
    __extends(AddListTokenPropertyForm, _super);
    function AddListTokenPropertyForm(props) {
        var _this = _super.call(this, props) || this;
        _this.label = "";
        _this.onAddToken = function (name) {
            return _this.props.onAddToken(name);
        };
        _this.onLabelBlur = function () {
            return _this.props.onLabelChange(_this.label);
        };
        _this.label = props.initialLabel || "";
        return _this;
    }
    AddListTokenPropertyForm.prototype.onLabelChange = function (label) {
        this.label = label;
    };
    AddListTokenPropertyForm.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "add-token-list-property-form" },
            react_1.default.createElement(kaleidoscope_1.TextInput, { className: "add-token-list-property-form__label-input", label: "Property label", value: this.label, onBlur: this.onLabelBlur, onChange: this.onLabelChange }),
            react_1.default.createElement(AddTokenInput_1.AddTokenInput, { label: "Property Name", placeholder: "E.g description", maxTokenLength: Types_1.MAX_CUSTOM_TOKEN_NAME_LENGTH, onAddToken: this.onAddToken })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddListTokenPropertyForm.prototype, "label", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AddListTokenPropertyForm.prototype, "onLabelChange", null);
    AddListTokenPropertyForm = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AddListTokenPropertyForm);
    return AddListTokenPropertyForm;
}(react_1.default.Component));
exports.AddListTokenPropertyForm = AddListTokenPropertyForm;
